import { __extends } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextWrapper } from 'uitk-react-utils';
import styles from './uitk-checkbox.css';
var getClassNameList = classNames.bind(styles);
var UitkCheckboxGroup = /** @class */function (_super) {
  __extends(UitkCheckboxGroup, _super);
  function UitkCheckboxGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkCheckboxGroup.prototype.render = function () {
    var _a = this.props,
      children = _a.children,
      errorMessage = _a.errorMessage,
      group = _a.group,
      legendLabel = _a.legendLabel;
    return React.createElement(UitkContextWrapper, null, function (context, data) {
      return React.createElement("fieldset", {
        className: getClassNameList('uitk-checkbox-group')
      }, React.createElement("legend", {
        className: getClassNameList('is-visually-hidden')
      }, legendLabel || group, (data === null || data === void 0 ? void 0 : data.collapsed) && ((data === null || data === void 0 ? void 0 : data.srMessage) ? ". ".concat(data === null || data === void 0 ? void 0 : data.srMessage) : '')), errorMessage && React.createElement("p", {
        className: getClassNameList('uitk-checkbox-error', 'uitk-checkbox-group-error')
      }, errorMessage), children);
    });
  };
  UitkCheckboxGroup.displayName = 'UitkCheckboxGroup';
  return UitkCheckboxGroup;
}(React.Component);
export { UitkCheckboxGroup };